import React from 'react';
import './index.scss';

export default function CategorieDropdown({ categories, onSelectCategory, defaultItem, rightAlign }) {
  const [activeDropdown, setActiveDropdown] = React.useState(false);
  const selectRef = React.useRef(null);

  const activeDrop = () => {
    if (!activeDropdown) {
      selectRef.current.focus();
      setActiveDropdown(true);
    } else {
      selectRef.current.blur();
      setActiveDropdown(false);
    }
  };
  const handleChange = (e) => {
    e.preventDefault();
    activeDrop();
    onSelectCategory(e.target.value);
  };

  return (
    <div className={rightAlign ? 'categories-wrapper auto-margin-left' : 'categories-wrapper'}   >
      <div className="form-group custom-select">
        <label className={activeDropdown ? 'select-wrap active' : 'select-wrap'}>
          <select
            ref={selectRef}
            onChange={handleChange}
            onFocus={activeDrop}
            onBlur={activeDrop}
            className="form-control"
            name="categories"
            id="categories"
          >
            <option value={defaultItem.value} defaultValue>
              {defaultItem.text}
            </option>
            {categories.map((category) => {
              return (
                <option key={category.value} className="" value={category.value}>
                  {category.text}
                </option>
              );
            })}
          </select>
        </label>
      </div>
    </div>
  );
}
